import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SidebarModule } from 'primeng/sidebar';
import { EcommerceSearchInputComponent } from '../ecommerce-search-input/ecommerce-search-input.component';

@Component({
  selector: 'app-ecommerce-search-sidebar',
  standalone: true,
  imports: [
    CommonModule,
    EcommerceSearchInputComponent,
    RouterModule,
    SidebarModule,
  ],
  encapsulation: ViewEncapsulation.None,
  templateUrl: './ecommerce-search-sidebar.component.html',
  styleUrl: './ecommerce-search-sidebar.component.scss',
})
export class EcommerceSearchSidebarComponent {
  @Output() changeQuery = new EventEmitter<string | null>();
  @Output() deleteHistoryClick = new EventEmitter<void>();
  @Input() query: string | null = null;
  @Output() searchClick = new EventEmitter<string>();
  @Input() searchHistory: string[] | null = null;
  @ViewChild('searchInput') searchInput: EcommerceSearchInputComponent;
  isVisible = false;
  constructor() {}

  changeInputQuery(query: string | null): void {
    this.query = query;
    this.changeQuery.emit(this.query);
  }

  close(): void {
    this.changeQuery.emit(this.query);
    this.isVisible = false;
  }

  deleteSearchHistory(): void {
    this.deleteHistoryClick.emit();
  }

  isOpen(): boolean {
    return this.isVisible;
  }

  open(): void {
    this.isVisible = true;
    setTimeout(() => this.searchInput.focus(), 150);
  }

  searchQuery(query?: string): void {
    this.query = query ?? this.query;
    if (this.query) {
      this.searchClick.emit(this.query);
    }
  }
}
